import { ImageField, useRecordContext } from "react-admin";

const ImagePreview = ({ source }) => {
  let record = useRecordContext();
  if (!record?.[source]) {
    if (!record.rawFile) {
      // Existing image preview
      return <ImageField source={source} title="Imagen" />;
    }
    // Uploaded image preview
    record[source] = record.src;
  }
  return <ImageField source={source} record={record} title="Imagen" />;
};

export default ImagePreview;
